import { Component } from '@angular/core';
import { IonContent, IonHeader, IonTitle, IonToolbar } from '@ionic/angular/standalone';
import { ButtonComponent } from '@work-frontend-monorepo/work-ui/layout';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'sfg-app-global-start-mitarbeiter-tab',
  templateUrl: './global-start-mitarbeiter-tab.component.html',
  standalone: true,
  imports: [IonContent, IonHeader, IonTitle, IonToolbar, ButtonComponent, RouterLink, TranslatePipe],
})
export class GlobalStartMitarbeiterTabComponent {}
